/**
 * メールの確認まわりの日本語（en.verify.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 * 「このメールで登録したのがあなたでなければ…」「途中でやめると…」は管理の文言の案のまま（2026-09-28）
 */
import type { enVerify } from './en.verify';
import type { PluralMsg } from './index';

type VerifyMessages = { [K in keyof typeof enVerify]: (typeof enVerify)[K] extends string ? string : string | PluralMsg };

export const jaVerify: VerifyMessages = {
  'error.email_unverified': '先にメールアドレスを確かめてください。{product}から届いたメールのリンクを開くと済みます。',
  'oauth.error.email_unverified': '先にメールアドレスを確かめてから{provider}を追加してください。{product}から届いたメールのリンクを開くと済みます。',
  'error.password_reset_required': 'パスワードの追加は、メールで届くリンクから行います。',

  'emailUnverified.notice':
    'メールアドレス（{email}）があなたの物か、まだ確かめられていません。{product}から届いたメールのリンクを開いてください。開くまで、サーバーだけで使うキー（sk_）を作る・AIエージェントをつなぐ・ログイン方法を足す・出金の設定（受け取りの口座・パスキー）・前払いの入金と自動チャージはできません。',
  'emailUnverified.noticeLaunch':
    'メールアドレス（{email}）があなたの物か、まだ確かめられていません。{product}から届いたメールのリンクを開いてください。開くまで、サーバーだけで使うキー（sk_）を作る・AIエージェントをつなぐ・ログイン方法を足す・前払いの入金と自動チャージはできません。',
  'emailUnverified.resend': '確かめるメールをもう一度送る',
  'emailUnverified.sent': '送りました。受信箱（見つからなければ迷惑メールのフォルダも）を見てください。',
  'projects.secretKeysWithheld':
    'サーバーだけで使うキー（sk_）はまだありません。メールアドレスを確かめると作れます。届いたメールのリンクを開いてから、「キー（pk_ / sk_）」の画面で作るか、AIに「キーを用意して」と頼んでください（自分で打つなら {cmd}）。下のアプリに書き込むキー（pk_）はもう使えます。',

  'verify.doneTitle': 'メールアドレスを確かめました',
  'verify.confirmLead': 'ボタンを押すと、このメールアドレスがあなたの物だと確かめたことになり、{product}のアカウントで使えるようになります。',
  'verify.confirmButton': 'このメールアドレスを確かめる',
  'verify.otherDeviceNote': '登録したときとは別の端末やブラウザで開いた場合は、念のため、ここで新しいパスワードを決めてもらいます。',
  'verify.passwordTitle': '新しいパスワードを決めてください',
  'verify.passwordLead':
    'このメールアドレスで登録したのがあなたでなければ、ここで新しいパスワードを決めてください。保存すると、メールアドレスを確かめたことにもなります。念のため、ほかの端末のログインはすべてログアウトしました。',
  'verify.stopNote': '途中でやめると、今のパスワードではログインできません。あとで{link}から設定できます。',
  'verify.forgotLink': '「パスワードを忘れた」',
  'verify.expired': 'この画面の期限（30 分）が切れました。{link}から新しいパスワードを設定してください。',

  'login.sendSetLink': 'リンクをメールで送る',
  'login.setViaEmail': 'パスワードの追加は、{email} に届くリンクから行います（受信箱を持つ本人だけが設定できます）。',
  'login.setLinkSent': '{email} にリンクを送りました。開いてパスワードを設定してください（30 分で期限が切れます）。'
};
